import {getQuery, postQuery, putQuery, removeQuery} from "@/modules/common/utils";

const NEW_INVOICE_PATH = 'invoices/new_invoice';
const NEW_ESTIMATE_PATH = 'estimates/new_estimate';

const newInvoice = (client_uid, matter_uid, invoice_uid, from_estimate_uid) => getQuery(`${NEW_INVOICE_PATH}`, {client_uid, matter_uid, invoice_uid, from_estimate_uid});
const newEstimate = (client_uid, matter_uid, estimate_uid) => getQuery(`${NEW_ESTIMATE_PATH}`, {client_uid, matter_uid, estimate_uid});

const createMultiActivityInvoice = (params) => {
  params.new_api = true;
  return postQuery('/business/payments/v1/invoices',params)
}

const updateMultiActivityInvoice = (params, invoice_uid) => {
  params.new_api = true;
  return putQuery(`/business/payments/v1/invoices/${invoice_uid}`, params)
}

const createEstimate = (params) => {
  params.new_api = true;
  return postQuery('/business/payments/v1/estimates',params)
}

const updateEstimate = (params, estimate_uid) => {
  params.new_api = true;
  return putQuery(`/business/payments/v1/estimates/${estimate_uid}`, params)
}

const createDeposit = (params) => {
  params.new_api = true;
  return postQuery(`/business/payments/v1/deposits`, params);
}

const getDeposit = (params) => {
  return getQuery(`/business/payments/v1/deposits`, {
    new_api: true,
    "filter[entity_uid][eq]": params.entity_uid,
    "filter[entity_type][in]": params.entity_type
  });
}

const updateDeposit = (params) => {
  params.new_api = true;
  return putQuery(`/business/payments/v1/deposits/${params.deposit.uid}`, params);
}

const deleteDeposit = (depositUid) => {
  const params = {new_api: true};
  return removeQuery(`/business/payments/v1/deposits/${depositUid}`, params);
}

export const itemizableService = {
  getDeposit,
  newInvoice,
  newEstimate,
  updateDeposit,
  deleteDeposit,
  createDeposit,
  createEstimate,
  updateEstimate,
  createMultiActivityInvoice,
  updateMultiActivityInvoice
}
